// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*@font-face {
    font-family: 'Poppins';
    src: url('../assets/fonts/Poppins/Poppins-Regular.ttf') format(truetype);
    font-weight: 400;
    font-style: normal;
}*/
/* --------- Cores Principais
Essas cores compõem a identidade visual da empresa 
*/
/* --------- Gradação Primária
Utilização em fundos, campos de preenchimentos, botões
ou caixas de diálogo, contrastes para textos ou elementos 
gráficos.
*/
/* --------- Gradação Neutros
Gradação até 400 -> Utilização em fundos, campos 
de preenchimentos, botões ou caixas de diálogo.

Gradação depois de 400 -> Utilização em contrastes 
para textos ou elementos gráficos neutros.
*/
/* --------- Texto Padrão
Utilização em tipografia padrão para corpo de texto,
 títulos e afins*/
/* --------- Texto em Destaque
Utilização em tipografia em destaque como displays, 
links, breadcrumbs, botões, avisos, call to action 
e afins*/
/* --------- Mensagens do Sistema
Utilização em mensagens de informações relevantes 
do sistema*/
/* ---------- Margens
Elementos estáticos ou inativos*/
/* ---------- Highlight
Elementos ativos, hover ou seleção*/
/* --------- Cantos arredondados
Orientações para aplicação de arredondamento 
em elementos gráficos nas interfaces MicroUniverso 
*/
/* O padrão para arredondamento de cantos no MicroUniverso Design System segue a regra de múltiplos de 4px.

A escala tem por objetivo criar um balanço estético que contribui com a compreensão geral da interface. */
@media (min-width: 1024px) {
  ._epZ3RG1FSPn5DnVWO5W {
    display: grid;
    grid_template_columns: repeat(12, 1fr);
    gap: 24px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  ._epZ3RG1FSPn5DnVWO5W {
    display: grid;
    grid_template_columns: repeat(8, 1fr);
    gap: 16px;
  }
}
@media (max-width: 768px) {
  ._epZ3RG1FSPn5DnVWO5W {
    display: grid;
    grid_template_columns: repeat(4, 1fr);
    gap: 8px;
  }
}

/*Quando for aplicar o grid, colocar o seguinte código na div desejada e
alterar o "ComponentModule" pelo nome do modulo do seu scss

<div className={ComponentModule.gridMU}>exemplo grid</div>
*/
/* --------- Sombras
 Orientações para aplicação de sombreamento em elementos gráficos
 nas interfaces MicroUniverso 
*/
/* As sombras ajudam na criação de hierarquia visual de informações e ênfase em elementos gráficos como imagens e caixas de diálogo */
/* --------- Display
Títulos com máximo destaque.*/
/* --------- Headings
Títulos padrão.*/
/* --------- Body
Corpo do texto.*/
/* --------- Pontuais
Pequenos textos para compor 
legendas, botões e afins.*/
* {
  box-sizing: border-box;
}

.kUxquKcUYmk_VSBjR8QP {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  flex-wrap: wrap;
}

.bFNcd0uVtFrn157nZjni {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.TZN7m1SN7PorIbTcNcPT.bNDxUbnuWNcG6eYFachg {
  width: 1%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.bNDxUbnuWNcG6eYFachg {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.UNKCZ_N4yuz4h4e_gqqy {
  width: 2%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.UNKCZ_N4yuz4h4e_gqqy {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.RrIQipTKVa3S6C0NVkLM {
  width: 3%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.RrIQipTKVa3S6C0NVkLM {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.MCpdoGwmvO3vC2gSgDzv {
  width: 4%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.MCpdoGwmvO3vC2gSgDzv {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.W1DAIF93jdjNSXqaY0Zv {
  width: 5%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.W1DAIF93jdjNSXqaY0Zv {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.ZM9mB3DeNIpbOMY9icVJ {
  width: 6%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.ZM9mB3DeNIpbOMY9icVJ {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.pjz5i_9IygDdzufC079G {
  width: 7%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.pjz5i_9IygDdzufC079G {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.gpB23IM29qOTpNYdGuvu {
  width: 8%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.gpB23IM29qOTpNYdGuvu {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.R1cGA3uaA5fgNgAuOrqb {
  width: 9%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.R1cGA3uaA5fgNgAuOrqb {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.cw8U3xb5s8yzHbICng8M {
  width: 10%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.cw8U3xb5s8yzHbICng8M {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.IQNlUi1KJEq1yld4sOwP {
  width: 11%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.IQNlUi1KJEq1yld4sOwP {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.AOkcS2PKxX3_TNHyQIIc {
  width: 12%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.AOkcS2PKxX3_TNHyQIIc {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.vDVojwCXkLbXQg4_5Ej1 {
  width: 13%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.vDVojwCXkLbXQg4_5Ej1 {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.CkIZUgAMUXE37SIjuWD0 {
  width: 14%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.CkIZUgAMUXE37SIjuWD0 {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.iKc5Hx7O1UlF2lHOplCg {
  width: 15%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.iKc5Hx7O1UlF2lHOplCg {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.mBj_Diir4CHCQrYmc80l {
  width: 16%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.mBj_Diir4CHCQrYmc80l {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.XUI5HyNNTFF7XEc78y70 {
  width: 17%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.XUI5HyNNTFF7XEc78y70 {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.IwJRqDpyY1MNdzAjbTTL {
  width: 18%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.IwJRqDpyY1MNdzAjbTTL {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.EMUeB2STJ6eKl_43tG8n {
  width: 19%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.EMUeB2STJ6eKl_43tG8n {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.xty4FA1WB2IqFzR3MyAK {
  width: 20%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.xty4FA1WB2IqFzR3MyAK {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.j9KKAG8LFvDyf8E1pZ3e {
  width: 21%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.j9KKAG8LFvDyf8E1pZ3e {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.X1qCdBTn28rZUJS7my8S {
  width: 22%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.X1qCdBTn28rZUJS7my8S {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.y8dJZZRdEqHy3rOxugAS {
  width: 23%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.y8dJZZRdEqHy3rOxugAS {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.U8kBOdzFJmsRrOGQ0J1K {
  width: 24%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.U8kBOdzFJmsRrOGQ0J1K {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.cCztUuGrHZfWnozziw8Q {
  width: 25%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.cCztUuGrHZfWnozziw8Q {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.yo_hwWeyxIWNOXhcMtQ0 {
  width: 26%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.yo_hwWeyxIWNOXhcMtQ0 {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.tMet84U4cGsXnTaFpdzk {
  width: 27%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.tMet84U4cGsXnTaFpdzk {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.NnuPIu4SAAOZWSYA8Kes {
  width: 28%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.NnuPIu4SAAOZWSYA8Kes {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.XXW6sa_xZuJcNqBIQ4Kn {
  width: 29%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.XXW6sa_xZuJcNqBIQ4Kn {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.m5gbr_GTD96ZmyW3dKls {
  width: 30%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.m5gbr_GTD96ZmyW3dKls {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.K395eJqAvbee9s2o8v8i {
  width: 31%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.K395eJqAvbee9s2o8v8i {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.PL0_XiSDl0K3kTPnE2qH {
  width: 32%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.PL0_XiSDl0K3kTPnE2qH {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.nWKPd86JC4VtBHnapKn9 {
  width: 33%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.nWKPd86JC4VtBHnapKn9 {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.blDEVLZQcQCue0C4wSSz {
  width: 34%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.blDEVLZQcQCue0C4wSSz {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.f9O1qCzJoTUJzduenpz7 {
  width: 35%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.f9O1qCzJoTUJzduenpz7 {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.xsCRxcAyUvoVIuCSklTo {
  width: 36%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.xsCRxcAyUvoVIuCSklTo {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.j4BCIr4_DP6LocuzaYb0 {
  width: 37%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.j4BCIr4_DP6LocuzaYb0 {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.PT6b1V9TVqFEhM5e9DAt {
  width: 38%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.PT6b1V9TVqFEhM5e9DAt {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.ievs36EKaiRLjZSsIAki {
  width: 39%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.ievs36EKaiRLjZSsIAki {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.tNlNVg9AgjhBNxiERyr5 {
  width: 40%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.tNlNVg9AgjhBNxiERyr5 {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT._WufVRiHWn6m29oRHuo1 {
  width: 41%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT._WufVRiHWn6m29oRHuo1 {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.Tnz_QCcY2zBgMOUAchwY {
  width: 42%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.Tnz_QCcY2zBgMOUAchwY {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.rak68GwPgOMAj_dV2yoh {
  width: 43%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.rak68GwPgOMAj_dV2yoh {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.J8r0EEq2xOJF4jyCrmTU {
  width: 44%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.J8r0EEq2xOJF4jyCrmTU {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.rlJSUROOHmbbS_X1K3up {
  width: 45%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.rlJSUROOHmbbS_X1K3up {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.SS790qqWXBk3nt4xWWe9 {
  width: 46%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.SS790qqWXBk3nt4xWWe9 {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.edJ7lbMTUp5D78_KMMhC {
  width: 47%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.edJ7lbMTUp5D78_KMMhC {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.Bj8j3X3Vs4oAgAuoMVA0 {
  width: 48%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.Bj8j3X3Vs4oAgAuoMVA0 {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.Qx8R_miy7INlEDiWEEJ7 {
  width: 49%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.Qx8R_miy7INlEDiWEEJ7 {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.T4igr1FJ7FfrTvHx5iZ5 {
  width: 50%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.T4igr1FJ7FfrTvHx5iZ5 {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.XNPpWkvakNLvr5VgrPWH {
  width: 51%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.XNPpWkvakNLvr5VgrPWH {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.R79GBNHS6AWWD0zfpB22 {
  width: 52%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.R79GBNHS6AWWD0zfpB22 {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.QSh0z9gvCh_dadxdY2ps {
  width: 53%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.QSh0z9gvCh_dadxdY2ps {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.GpSL_oHeXSTLyu7gLrBC {
  width: 54%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.GpSL_oHeXSTLyu7gLrBC {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.IWmSY5x_eAEKADThL8cB {
  width: 55%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.IWmSY5x_eAEKADThL8cB {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.SUKIWBxCahSaMfrcSUAs {
  width: 56%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.SUKIWBxCahSaMfrcSUAs {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.ZjEDESEabC8BNwMD3N9p {
  width: 57%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.ZjEDESEabC8BNwMD3N9p {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.AQQwMvQvfQw3_RyZc6hX {
  width: 58%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.AQQwMvQvfQw3_RyZc6hX {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.GrGr0EtW5Y3iQsv3sDKQ {
  width: 59%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.GrGr0EtW5Y3iQsv3sDKQ {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.PXfrfsCyRynMncMAfOUM {
  width: 60%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.PXfrfsCyRynMncMAfOUM {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.NT3wjCCmOP9v7Wok4U2E {
  width: 61%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.NT3wjCCmOP9v7Wok4U2E {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.MJe4MEWTYUsZTbiZtZyw {
  width: 62%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.MJe4MEWTYUsZTbiZtZyw {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.OZ57Ubst2KZeF8VYPYU7 {
  width: 63%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.OZ57Ubst2KZeF8VYPYU7 {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.oU1ufbOjpt_c5TDzMo6M {
  width: 64%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.oU1ufbOjpt_c5TDzMo6M {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.N6wWaABe83q6eODhUtin {
  width: 65%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.N6wWaABe83q6eODhUtin {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.uky25hgfQgvAE_IqUtZG {
  width: 66%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.uky25hgfQgvAE_IqUtZG {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.gOHCPPBnrvlwuhWPThTG {
  width: 67%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.gOHCPPBnrvlwuhWPThTG {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.gPhSCZECOQ6w3zzUDrMi {
  width: 68%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.gPhSCZECOQ6w3zzUDrMi {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.EXekBJoYvs__WZw45zfC {
  width: 69%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.EXekBJoYvs__WZw45zfC {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.AjEdArAPKa_KuN7qrhz5 {
  width: 70%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.AjEdArAPKa_KuN7qrhz5 {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.c6BFUuGHPcMIhVyBb6Ak {
  width: 71%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.c6BFUuGHPcMIhVyBb6Ak {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.rf4QEZfDz1kJROMZKmag {
  width: 72%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.rf4QEZfDz1kJROMZKmag {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.Lx2xv1Kc0Oz9Pl5W3KU3 {
  width: 73%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.Lx2xv1Kc0Oz9Pl5W3KU3 {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.lWni0JUdFULGTPXb_3_h {
  width: 74%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.lWni0JUdFULGTPXb_3_h {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT._vGcw2zUN26bXXIZUql4 {
  width: 75%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT._vGcw2zUN26bXXIZUql4 {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.dw521P6JB7O5IQy4IRRe {
  width: 76%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.dw521P6JB7O5IQy4IRRe {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.m2e3k3YjOiM1FFwqoGpY {
  width: 77%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.m2e3k3YjOiM1FFwqoGpY {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.BFeI68xGpqCLLZjQBVRH {
  width: 78%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.BFeI68xGpqCLLZjQBVRH {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.uuHyNMt9EZ7rnDSiNqb7 {
  width: 79%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.uuHyNMt9EZ7rnDSiNqb7 {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.QDHZ50DsR7Upz0h7s1J2 {
  width: 80%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.QDHZ50DsR7Upz0h7s1J2 {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.XXaN9acyogm10ugCayER {
  width: 81%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.XXaN9acyogm10ugCayER {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.kO0AwDouife8aDy3egoi {
  width: 82%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.kO0AwDouife8aDy3egoi {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.oZ9zoSS4vs2wYJa1yI6n {
  width: 83%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.oZ9zoSS4vs2wYJa1yI6n {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.lCI7ojj0fX7rUxSjjfx_ {
  width: 84%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.lCI7ojj0fX7rUxSjjfx_ {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.vA7VshOsoffGlz58VDg4 {
  width: 85%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.vA7VshOsoffGlz58VDg4 {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.qS6adJQ7xFBtjsSJImNJ {
  width: 86%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.qS6adJQ7xFBtjsSJImNJ {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.y3qK9WvMzxs4rSY2ZPy1 {
  width: 87%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.y3qK9WvMzxs4rSY2ZPy1 {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.CY7t4PwaPk2prJ692fiE {
  width: 88%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.CY7t4PwaPk2prJ692fiE {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.dUyVjyheHKD1f8Hj_q8h {
  width: 89%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.dUyVjyheHKD1f8Hj_q8h {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.vr4UG7H_e_bBW2WYs0dX {
  width: 90%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.vr4UG7H_e_bBW2WYs0dX {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.uJJt4QuWm93bRkCitckh {
  width: 91%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.uJJt4QuWm93bRkCitckh {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.fsk2IxzFvYEYo5a5MOwb {
  width: 92%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.fsk2IxzFvYEYo5a5MOwb {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.ItL3ATxM1vUUj1UHq2cY {
  width: 93%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.ItL3ATxM1vUUj1UHq2cY {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.rQFmbYUWlYMI579KnWFS {
  width: 94%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.rQFmbYUWlYMI579KnWFS {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.ytSxsqv0jqaWvn0LUgIZ {
  width: 95%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.ytSxsqv0jqaWvn0LUgIZ {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.WWvKLJWXJ28LoA7tyIHF {
  width: 96%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.WWvKLJWXJ28LoA7tyIHF {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.CIovhKAVecZyydqFlpZx {
  width: 97%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.CIovhKAVecZyydqFlpZx {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.UvNX5NNQS93wOaR9GubH {
  width: 98%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.UvNX5NNQS93wOaR9GubH {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.d48vK0ww2sLt1xriuA7v {
  width: 99%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.d48vK0ww2sLt1xriuA7v {
    width: 100%;
  }
}
.TZN7m1SN7PorIbTcNcPT.G7Jv8619lieRUHk2Bpzy {
  width: 100%;
  height: auto;
}
@media (max-width: 960px) {
  .TZN7m1SN7PorIbTcNcPT.G7Jv8619lieRUHk2Bpzy {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/componentes/Formulario/FormularioGrid/FormularioGrid.module.scss","webpack://./src/styles/_font.scss","webpack://./src/styles/_colors.scss","webpack://./src/styles/_border.scss","webpack://./src/styles/_borderRadius.scss","webpack://./src/styles/_grid.scss","webpack://./src/styles/_shadow.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;;EAAA;ACAA;;CAAA;AASA;;;;CAAA;AAgBA;;;;;;CAAA;AAkBA;;iBAAA;AAMA;;;QAAA;AAUA;;WAAA;AC1DA;gCAAA;AASA;mCAAA;ACVA;;;CAAA;AAeA;;yGAAA;ACiDE;EADF;IArBE,aAAA;IACA,sCAAA;IACA,SAlBoB;ELuBpB;AACF;AKkBE;EALF;IAdE,aAAA;IACA,qCAAA;IACA,SAnBmB;ELwBnB;AACF;AKeE;EATF;IAPE,aAAA;IACA,qCAAA;IACA,QApBmB;ELyBnB;AACF;;AKaA;;;;CAAA;AC7EA;;;CAAA;AASA,qIAAA;ACTA;6BAAA;AAYA;gBAAA;AAiBA;gBAAA;AAiBA;;0BAAA;APtCA;EACI,sBAAA;AA8EJ;;AA3EA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;AA8EJ;;AA3EA;EACI,WAAA;EACA,aAAA;EACA,eAAA;AA8EJ;;AAxEQ;EACE,SAAA;EACA,YAAA;AA2EV;AAzEY;EAJJ;IAKQ,WAAA;EA4Ed;AACF;AAlFQ;EACE,SAAA;EACA,YAAA;AAoFV;AAlFY;EAJJ;IAKQ,WAAA;EAqFd;AACF;AA3FQ;EACE,SAAA;EACA,YAAA;AA6FV;AA3FY;EAJJ;IAKQ,WAAA;EA8Fd;AACF;AApGQ;EACE,SAAA;EACA,YAAA;AAsGV;AApGY;EAJJ;IAKQ,WAAA;EAuGd;AACF;AA7GQ;EACE,SAAA;EACA,YAAA;AA+GV;AA7GY;EAJJ;IAKQ,WAAA;EAgHd;AACF;AAtHQ;EACE,SAAA;EACA,YAAA;AAwHV;AAtHY;EAJJ;IAKQ,WAAA;EAyHd;AACF;AA/HQ;EACE,SAAA;EACA,YAAA;AAiIV;AA/HY;EAJJ;IAKQ,WAAA;EAkId;AACF;AAxIQ;EACE,SAAA;EACA,YAAA;AA0IV;AAxIY;EAJJ;IAKQ,WAAA;EA2Id;AACF;AAjJQ;EACE,SAAA;EACA,YAAA;AAmJV;AAjJY;EAJJ;IAKQ,WAAA;EAoJd;AACF;AA1JQ;EACE,UAAA;EACA,YAAA;AA4JV;AA1JY;EAJJ;IAKQ,WAAA;EA6Jd;AACF;AAnKQ;EACE,UAAA;EACA,YAAA;AAqKV;AAnKY;EAJJ;IAKQ,WAAA;EAsKd;AACF;AA5KQ;EACE,UAAA;EACA,YAAA;AA8KV;AA5KY;EAJJ;IAKQ,WAAA;EA+Kd;AACF;AArLQ;EACE,UAAA;EACA,YAAA;AAuLV;AArLY;EAJJ;IAKQ,WAAA;EAwLd;AACF;AA9LQ;EACE,UAAA;EACA,YAAA;AAgMV;AA9LY;EAJJ;IAKQ,WAAA;EAiMd;AACF;AAvMQ;EACE,UAAA;EACA,YAAA;AAyMV;AAvMY;EAJJ;IAKQ,WAAA;EA0Md;AACF;AAhNQ;EACE,UAAA;EACA,YAAA;AAkNV;AAhNY;EAJJ;IAKQ,WAAA;EAmNd;AACF;AAzNQ;EACE,UAAA;EACA,YAAA;AA2NV;AAzNY;EAJJ;IAKQ,WAAA;EA4Nd;AACF;AAlOQ;EACE,UAAA;EACA,YAAA;AAoOV;AAlOY;EAJJ;IAKQ,WAAA;EAqOd;AACF;AA3OQ;EACE,UAAA;EACA,YAAA;AA6OV;AA3OY;EAJJ;IAKQ,WAAA;EA8Od;AACF;AApPQ;EACE,UAAA;EACA,YAAA;AAsPV;AApPY;EAJJ;IAKQ,WAAA;EAuPd;AACF;AA7PQ;EACE,UAAA;EACA,YAAA;AA+PV;AA7PY;EAJJ;IAKQ,WAAA;EAgQd;AACF;AAtQQ;EACE,UAAA;EACA,YAAA;AAwQV;AAtQY;EAJJ;IAKQ,WAAA;EAyQd;AACF;AA/QQ;EACE,UAAA;EACA,YAAA;AAiRV;AA/QY;EAJJ;IAKQ,WAAA;EAkRd;AACF;AAxRQ;EACE,UAAA;EACA,YAAA;AA0RV;AAxRY;EAJJ;IAKQ,WAAA;EA2Rd;AACF;AAjSQ;EACE,UAAA;EACA,YAAA;AAmSV;AAjSY;EAJJ;IAKQ,WAAA;EAoSd;AACF;AA1SQ;EACE,UAAA;EACA,YAAA;AA4SV;AA1SY;EAJJ;IAKQ,WAAA;EA6Sd;AACF;AAnTQ;EACE,UAAA;EACA,YAAA;AAqTV;AAnTY;EAJJ;IAKQ,WAAA;EAsTd;AACF;AA5TQ;EACE,UAAA;EACA,YAAA;AA8TV;AA5TY;EAJJ;IAKQ,WAAA;EA+Td;AACF;AArUQ;EACE,UAAA;EACA,YAAA;AAuUV;AArUY;EAJJ;IAKQ,WAAA;EAwUd;AACF;AA9UQ;EACE,UAAA;EACA,YAAA;AAgVV;AA9UY;EAJJ;IAKQ,WAAA;EAiVd;AACF;AAvVQ;EACE,UAAA;EACA,YAAA;AAyVV;AAvVY;EAJJ;IAKQ,WAAA;EA0Vd;AACF;AAhWQ;EACE,UAAA;EACA,YAAA;AAkWV;AAhWY;EAJJ;IAKQ,WAAA;EAmWd;AACF;AAzWQ;EACE,UAAA;EACA,YAAA;AA2WV;AAzWY;EAJJ;IAKQ,WAAA;EA4Wd;AACF;AAlXQ;EACE,UAAA;EACA,YAAA;AAoXV;AAlXY;EAJJ;IAKQ,WAAA;EAqXd;AACF;AA3XQ;EACE,UAAA;EACA,YAAA;AA6XV;AA3XY;EAJJ;IAKQ,WAAA;EA8Xd;AACF;AApYQ;EACE,UAAA;EACA,YAAA;AAsYV;AApYY;EAJJ;IAKQ,WAAA;EAuYd;AACF;AA7YQ;EACE,UAAA;EACA,YAAA;AA+YV;AA7YY;EAJJ;IAKQ,WAAA;EAgZd;AACF;AAtZQ;EACE,UAAA;EACA,YAAA;AAwZV;AAtZY;EAJJ;IAKQ,WAAA;EAyZd;AACF;AA/ZQ;EACE,UAAA;EACA,YAAA;AAiaV;AA/ZY;EAJJ;IAKQ,WAAA;EAkad;AACF;AAxaQ;EACE,UAAA;EACA,YAAA;AA0aV;AAxaY;EAJJ;IAKQ,WAAA;EA2ad;AACF;AAjbQ;EACE,UAAA;EACA,YAAA;AAmbV;AAjbY;EAJJ;IAKQ,WAAA;EAobd;AACF;AA1bQ;EACE,UAAA;EACA,YAAA;AA4bV;AA1bY;EAJJ;IAKQ,WAAA;EA6bd;AACF;AAncQ;EACE,UAAA;EACA,YAAA;AAqcV;AAncY;EAJJ;IAKQ,WAAA;EAscd;AACF;AA5cQ;EACE,UAAA;EACA,YAAA;AA8cV;AA5cY;EAJJ;IAKQ,WAAA;EA+cd;AACF;AArdQ;EACE,UAAA;EACA,YAAA;AAudV;AArdY;EAJJ;IAKQ,WAAA;EAwdd;AACF;AA9dQ;EACE,UAAA;EACA,YAAA;AAgeV;AA9dY;EAJJ;IAKQ,WAAA;EAied;AACF;AAveQ;EACE,UAAA;EACA,YAAA;AAyeV;AAveY;EAJJ;IAKQ,WAAA;EA0ed;AACF;AAhfQ;EACE,UAAA;EACA,YAAA;AAkfV;AAhfY;EAJJ;IAKQ,WAAA;EAmfd;AACF;AAzfQ;EACE,UAAA;EACA,YAAA;AA2fV;AAzfY;EAJJ;IAKQ,WAAA;EA4fd;AACF;AAlgBQ;EACE,UAAA;EACA,YAAA;AAogBV;AAlgBY;EAJJ;IAKQ,WAAA;EAqgBd;AACF;AA3gBQ;EACE,UAAA;EACA,YAAA;AA6gBV;AA3gBY;EAJJ;IAKQ,WAAA;EA8gBd;AACF;AAphBQ;EACE,UAAA;EACA,YAAA;AAshBV;AAphBY;EAJJ;IAKQ,WAAA;EAuhBd;AACF;AA7hBQ;EACE,UAAA;EACA,YAAA;AA+hBV;AA7hBY;EAJJ;IAKQ,WAAA;EAgiBd;AACF;AAtiBQ;EACE,UAAA;EACA,YAAA;AAwiBV;AAtiBY;EAJJ;IAKQ,WAAA;EAyiBd;AACF;AA/iBQ;EACE,UAAA;EACA,YAAA;AAijBV;AA/iBY;EAJJ;IAKQ,WAAA;EAkjBd;AACF;AAxjBQ;EACE,UAAA;EACA,YAAA;AA0jBV;AAxjBY;EAJJ;IAKQ,WAAA;EA2jBd;AACF;AAjkBQ;EACE,UAAA;EACA,YAAA;AAmkBV;AAjkBY;EAJJ;IAKQ,WAAA;EAokBd;AACF;AA1kBQ;EACE,UAAA;EACA,YAAA;AA4kBV;AA1kBY;EAJJ;IAKQ,WAAA;EA6kBd;AACF;AAnlBQ;EACE,UAAA;EACA,YAAA;AAqlBV;AAnlBY;EAJJ;IAKQ,WAAA;EAslBd;AACF;AA5lBQ;EACE,UAAA;EACA,YAAA;AA8lBV;AA5lBY;EAJJ;IAKQ,WAAA;EA+lBd;AACF;AArmBQ;EACE,UAAA;EACA,YAAA;AAumBV;AArmBY;EAJJ;IAKQ,WAAA;EAwmBd;AACF;AA9mBQ;EACE,UAAA;EACA,YAAA;AAgnBV;AA9mBY;EAJJ;IAKQ,WAAA;EAinBd;AACF;AAvnBQ;EACE,UAAA;EACA,YAAA;AAynBV;AAvnBY;EAJJ;IAKQ,WAAA;EA0nBd;AACF;AAhoBQ;EACE,UAAA;EACA,YAAA;AAkoBV;AAhoBY;EAJJ;IAKQ,WAAA;EAmoBd;AACF;AAzoBQ;EACE,UAAA;EACA,YAAA;AA2oBV;AAzoBY;EAJJ;IAKQ,WAAA;EA4oBd;AACF;AAlpBQ;EACE,UAAA;EACA,YAAA;AAopBV;AAlpBY;EAJJ;IAKQ,WAAA;EAqpBd;AACF;AA3pBQ;EACE,UAAA;EACA,YAAA;AA6pBV;AA3pBY;EAJJ;IAKQ,WAAA;EA8pBd;AACF;AApqBQ;EACE,UAAA;EACA,YAAA;AAsqBV;AApqBY;EAJJ;IAKQ,WAAA;EAuqBd;AACF;AA7qBQ;EACE,UAAA;EACA,YAAA;AA+qBV;AA7qBY;EAJJ;IAKQ,WAAA;EAgrBd;AACF;AAtrBQ;EACE,UAAA;EACA,YAAA;AAwrBV;AAtrBY;EAJJ;IAKQ,WAAA;EAyrBd;AACF;AA/rBQ;EACE,UAAA;EACA,YAAA;AAisBV;AA/rBY;EAJJ;IAKQ,WAAA;EAksBd;AACF;AAxsBQ;EACE,UAAA;EACA,YAAA;AA0sBV;AAxsBY;EAJJ;IAKQ,WAAA;EA2sBd;AACF;AAjtBQ;EACE,UAAA;EACA,YAAA;AAmtBV;AAjtBY;EAJJ;IAKQ,WAAA;EAotBd;AACF;AA1tBQ;EACE,UAAA;EACA,YAAA;AA4tBV;AA1tBY;EAJJ;IAKQ,WAAA;EA6tBd;AACF;AAnuBQ;EACE,UAAA;EACA,YAAA;AAquBV;AAnuBY;EAJJ;IAKQ,WAAA;EAsuBd;AACF;AA5uBQ;EACE,UAAA;EACA,YAAA;AA8uBV;AA5uBY;EAJJ;IAKQ,WAAA;EA+uBd;AACF;AArvBQ;EACE,UAAA;EACA,YAAA;AAuvBV;AArvBY;EAJJ;IAKQ,WAAA;EAwvBd;AACF;AA9vBQ;EACE,UAAA;EACA,YAAA;AAgwBV;AA9vBY;EAJJ;IAKQ,WAAA;EAiwBd;AACF;AAvwBQ;EACE,UAAA;EACA,YAAA;AAywBV;AAvwBY;EAJJ;IAKQ,WAAA;EA0wBd;AACF;AAhxBQ;EACE,UAAA;EACA,YAAA;AAkxBV;AAhxBY;EAJJ;IAKQ,WAAA;EAmxBd;AACF;AAzxBQ;EACE,UAAA;EACA,YAAA;AA2xBV;AAzxBY;EAJJ;IAKQ,WAAA;EA4xBd;AACF;AAlyBQ;EACE,UAAA;EACA,YAAA;AAoyBV;AAlyBY;EAJJ;IAKQ,WAAA;EAqyBd;AACF;AA3yBQ;EACE,UAAA;EACA,YAAA;AA6yBV;AA3yBY;EAJJ;IAKQ,WAAA;EA8yBd;AACF;AApzBQ;EACE,UAAA;EACA,YAAA;AAszBV;AApzBY;EAJJ;IAKQ,WAAA;EAuzBd;AACF;AA7zBQ;EACE,UAAA;EACA,YAAA;AA+zBV;AA7zBY;EAJJ;IAKQ,WAAA;EAg0Bd;AACF;AAt0BQ;EACE,UAAA;EACA,YAAA;AAw0BV;AAt0BY;EAJJ;IAKQ,WAAA;EAy0Bd;AACF;AA/0BQ;EACE,UAAA;EACA,YAAA;AAi1BV;AA/0BY;EAJJ;IAKQ,WAAA;EAk1Bd;AACF;AAx1BQ;EACE,UAAA;EACA,YAAA;AA01BV;AAx1BY;EAJJ;IAKQ,WAAA;EA21Bd;AACF;AAj2BQ;EACE,UAAA;EACA,YAAA;AAm2BV;AAj2BY;EAJJ;IAKQ,WAAA;EAo2Bd;AACF;AA12BQ;EACE,UAAA;EACA,YAAA;AA42BV;AA12BY;EAJJ;IAKQ,WAAA;EA62Bd;AACF;AAn3BQ;EACE,UAAA;EACA,YAAA;AAq3BV;AAn3BY;EAJJ;IAKQ,WAAA;EAs3Bd;AACF;AA53BQ;EACE,UAAA;EACA,YAAA;AA83BV;AA53BY;EAJJ;IAKQ,WAAA;EA+3Bd;AACF;AAr4BQ;EACE,UAAA;EACA,YAAA;AAu4BV;AAr4BY;EAJJ;IAKQ,WAAA;EAw4Bd;AACF;AA94BQ;EACE,UAAA;EACA,YAAA;AAg5BV;AA94BY;EAJJ;IAKQ,WAAA;EAi5Bd;AACF;AAv5BQ;EACE,UAAA;EACA,YAAA;AAy5BV;AAv5BY;EAJJ;IAKQ,WAAA;EA05Bd;AACF;AAh6BQ;EACE,UAAA;EACA,YAAA;AAk6BV;AAh6BY;EAJJ;IAKQ,WAAA;EAm6Bd;AACF;AAz6BQ;EACE,UAAA;EACA,YAAA;AA26BV;AAz6BY;EAJJ;IAKQ,WAAA;EA46Bd;AACF;AAl7BQ;EACE,UAAA;EACA,YAAA;AAo7BV;AAl7BY;EAJJ;IAKQ,WAAA;EAq7Bd;AACF;AA37BQ;EACE,UAAA;EACA,YAAA;AA67BV;AA37BY;EAJJ;IAKQ,WAAA;EA87Bd;AACF;AAp8BQ;EACE,WAAA;EACA,YAAA;AAs8BV;AAp8BY;EAJJ;IAKQ,WAAA;EAu8Bd;AACF","sourcesContent":["@use '../../../styles/border' as border;\r\n@use '../../../styles/borderRadius' as borderRadius;\r\n@use '../../../styles/colors' as colors;\r\n@use '../../../styles/font' as font;\r\n@use '../../../styles/grid' as grid;\r\n@use '../../../styles/shadow' as shadow;\r\n@use '../../../styles/typography' as typography;\r\n\r\n* {\r\n    box-sizing: border-box;\r\n}\r\n\r\n.formularioGridContainer {\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex-wrap: wrap;\r\n    width: 100%;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.formularioGridRow {\r\n    width: 100%;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.formularioGridColumn {\r\n\r\n    @for $i from 1 through 100 {\r\n        &.width#{$i}{\r\n          width: 1% * $i;\r\n          height: auto;\r\n\r\n            @media (max-width: 960px) {\r\n                width: 100%;\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n","/*@font-face {\r\n    font-family: 'Poppins';\r\n    src: url('../assets/fonts/Poppins/Poppins-Regular.ttf') format(truetype);\r\n    font-weight: 400;\r\n    font-style: normal;\r\n}*/\r\n@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');","/* --------- Cores Principais\r\nEssas cores compõem a identidade visual da empresa \r\n*/\r\n$azul-mu:#43A4D1;\r\n$azul-escuro-mu:#002E51;\r\n$laranja-mu:#F4762A;\r\n$branco-mu:#FDFDFD;\r\n$cinza-mu:#646363;\r\n\r\n/* --------- Gradação Primária\r\nUtilização em fundos, campos de preenchimentos, botões\r\nou caixas de diálogo, contrastes para textos ou elementos \r\ngráficos.\r\n*/\r\n$azul-mu-50:#E8F4FA;\r\n$azul-mu-100:#D9EDF6;\r\n$azul-mu-200:#B4DBED;\r\n$azul-mu-300:#8EC8E3;\r\n$azul-mu-400:#69B6DA;\r\n$azul-mu-500:#43A4D1;\r\n$azul-mu-600:#0172CB;\r\n$azul-mu-700:#015BA2;\r\n$azul-mu-800:#01447A;\r\n$azul-mu-900:#002E51;\r\n\r\n/* --------- Gradação Neutros\r\nGradação até 400 -> Utilização em fundos, campos \r\nde preenchimentos, botões ou caixas de diálogo.\r\n\r\nGradação depois de 400 -> Utilização em contrastes \r\npara textos ou elementos gráficos neutros.\r\n*/\r\n$neutro-mu-50:#FDFDFD;\r\n$neutro-mu-100:#F3F3F3;\r\n$neutro-mu-200:#DADADA;\r\n$neutro-mu-300:#CDCDCD;\r\n$neutro-mu-400:#C1C1C1;\r\n$neutro-mu-500:#A2A1A1;\r\n$neutro-mu-600:#646363;\r\n$neutro-mu-700:#504F4F;\r\n$neutro-mu-800:#3C3B3B;\r\n$neutro-mu-900:#001729;\r\n\r\n/* --------- Texto Padrão\r\nUtilização em tipografia padrão para corpo de texto,\r\n títulos e afins*/\r\n$texto-cinza:#646363;\r\n$texto-preto:#001729;\r\n\r\n/* --------- Texto em Destaque\r\nUtilização em tipografia em destaque como displays, \r\nlinks, breadcrumbs, botões, avisos, call to action \r\ne afins*/\r\n$destaque-azul-mu-500:#43A4D1;\r\n$destaque-azul-mu-600:#0172CB;\r\n$destaque-azul-escuro-mu:#002E51;\r\n$destaque-laranja-mu:#F4762A;\r\n$destaque-branco-mu:#FDFDFD;\r\n\r\n/* --------- Mensagens do Sistema\r\nUtilização em mensagens de informações relevantes \r\ndo sistema*/\r\n$status-azul-mu:#0172CB;\r\n$status-azul-mu-fill:#69B6DA;\r\n$status-azul-mu-bg:#E8F4FA;\r\n$status-verde-mu:#119822;\r\n$status-verde-mu-fill:#70C17A;\r\n$status-verde-mu-bg:#E2F2E5;\r\n$status-laranja-mu:#F4762A;\r\n$status-laranja-mu-fill:#F8AD7F;\r\n$status-laranja-mu-bg:#FDE4D4;\r\n$status-vermelho-mu:#D21C1C;\r\n$status-vermelho-mu-fill:#E47777;\r\n$status-vermelho-mu-bg:#F8DBDB;\r\n$status-amarelo-mu:#EFCA08;\r\n$status-amarelo-mu-fill:#F6E483;\r\n$status-amarelo-mu-bg:#FDFAE9;\r\n","@use 'colors' as colors;\r\n/* ---------- Margens\r\nElementos estáticos ou inativos*/\r\n$margem-stroke-style:solid;\r\n$margem-border:1px;\r\n$margem-alignment:inside;\r\n$margem-color-1:#BAB8AC; \r\n$margem-color-2:#DDDBD6;\r\n$margem-color-3:#BAB8AC;\r\n\r\n/* ---------- Highlight\r\nElementos ativos, hover ou seleção*/\r\n$margem-color-ativo: colors.$laranja-mu; \r\n$margem-color-hover: colors.$azul-mu;\r\n$margem-color-selecao: colors.$azul-mu-600;\r\n","/* --------- Cantos arredondados\r\nOrientações para aplicação de arredondamento \r\nem elementos gráficos nas interfaces MicroUniverso \r\n*/\r\n\r\n$raio-4: 4px;\r\n$raio-8: 8px;\r\n$raio-12: 12px;\r\n$raio-16: 16px;\r\n$raio-20: 20px;\r\n$raio-24: 24px;\r\n$raio-32: 32px;\r\n$raio-48: 12px;\r\n$raio-999:999px;\r\n\r\n/* O padrão para arredondamento de cantos no MicroUniverso Design System segue a regra de múltiplos de 4px.\r\n\r\nA escala tem por objetivo criar um balanço estético que contribui com a compreensão geral da interface. */","//spacing\r\n\r\n$spacing-4 : 4px;\r\n$spacing-8 : 8px;\r\n$spacing-12 : 12px;\r\n$spacing-16 : 16px;\r\n$spacing-20 : 20px;\r\n$spacing-24 : 24px;\r\n$spacing-32 : 32px;\r\n$spacing-40: 40px;\r\n$spacing-48 : 48px;\r\n$spacing-56: 56px;\r\n$spacing-64 : 64px;\r\n$spacing-88 : 88px;\r\n$spacing-112 : 112px;\r\n$spacing-160 : 160px;\r\n$spacing-192 : 192px;\r\n$spacing-256 : 256px;\r\n$spacing-320 : 320px;\r\n$spacing-448: 448px;\r\n$spacing-512 : 512px;\r\n\r\n\r\n// Variáveis para grid desktop\r\n$grid_container_min_width_desktop: 1024px; // Defina o valor apropriado\r\n$grid_columns_desktop: 12;\r\n$grid_gutter_desktop: 24px;\r\n\r\n// Variáveis para grid tablet\r\n$grid_container_min_width_tablet: 768px;\r\n$grid_columns_tablet: 8;\r\n$grid_margin_tablet: 40px;\r\n$grid_gutter_tablet: 16px;\r\n\r\n// Variáveis para grid mobile\r\n$grid_container_min_width_mobile: 320px;\r\n$grid_columns_mobile: 4;\r\n$grid_margin_mobile: 20px;\r\n$grid_gutter_mobile: 8px;\r\n\r\n// Mixin para a grid _desktop\r\n@mixin make_grid_desktop($columns, $gutter_width) {\r\n  display: grid;\r\n  grid_template_columns: repeat($columns, 1fr);\r\n  gap: $gutter_width;\r\n}\r\n\r\n// Mixin para a grid _tablet\r\n@mixin make_grid_tablet($columns, $gutter_width) {\r\n  display: grid;\r\n  grid_template_columns: repeat($columns, 1fr);\r\n  gap: $gutter_width;\r\n}\r\n\r\n// Mixin para a grid _mobile\r\n@mixin make_grid_mobile($columns, $gutter_width) {\r\n  display: grid;\r\n  grid_template_columns: repeat($columns, 1fr);\r\n  gap: $gutter_width;\r\n}\r\n\r\n// Aplicando as grids\r\n\r\n.gridMU {\r\n  @media (min-width: $grid_container_min_width_desktop) {\r\n    @include make_grid_desktop($grid_columns_desktop, $grid_gutter_desktop);\r\n  }\r\n\r\n  @media (min-width: $grid_container_min_width_tablet) and (max-width: $grid_container_min_width_desktop) {\r\n    @include make_grid_tablet($grid_columns_tablet, $grid_gutter_tablet);\r\n  }\r\n\r\n  @media (max-width: $grid_container_min_width_tablet) {\r\n    @include make_grid_mobile($grid_columns_mobile, $grid_gutter_mobile);\r\n  }\r\n}\r\n\r\n/*Quando for aplicar o grid, colocar o seguinte código na div desejada e\r\nalterar o \"ComponentModule\" pelo nome do modulo do seu scss\r\n\r\n<div className={ComponentModule.gridMU}>exemplo grid</div>\r\n*/","/* --------- Sombras\r\n Orientações para aplicação de sombreamento em elementos gráficos\r\n nas interfaces MicroUniverso \r\n*/\r\n\r\n$sombra-mu-1: 0px 0px 6px 0px rgba(24, 24, 24, 0.20);\r\n$sombra-mu-2: 0px 2px 12px 0px rgba(24, 24, 24, 0.1);\r\n$sombra-mu-3: 0px 2px 16px 0px rgba(24, 24, 24, 0.05);\r\n\r\n/* As sombras ajudam na criação de hierarquia visual de informações e ênfase em elementos gráficos como imagens e caixas de diálogo */","/* --------- Display\r\nTítulos com máximo destaque.*/\r\n$display-1-weight: 700;\r\n$display-1-size: 80px;\r\n$display-1-line-height: 88px;\r\n$display-1-letter-spacing: -2px;\r\n\r\n$display-2-weight: 700;\r\n$display-2-size: 48px;\r\n$display-2-line-height: 56px;\r\n$display-2-letter-spacing: -1px;\r\n\r\n/* --------- Headings\r\nTítulos padrão.*/\r\n$heading-1-weight: 700;\r\n$heading-1-size: 32px;\r\n$heading-1-line-height: 40px;\r\n$heading-1-letter-spacing: -0.5px;\r\n\r\n$heading-2-weight: 700;\r\n$heading-2-size: 24px;\r\n$heading-2-line-height: 32px;\r\n$heading-2-letter-spacing: -0.25px;\r\n\r\n$heading-3-weight: 700;\r\n$heading-3-size: 18px;\r\n$heading-3-line-height: 26px;\r\n$heading-3-letter-spacing: -0.25px;\r\n\r\n/* --------- Body\r\nCorpo do texto.*/\r\n$body-1-weight: 500;\r\n$body-1-weight-bold: 700;\r\n$body-1-size: 16px;\r\n$body-1-line-height: 24px;\r\n\r\n$body-2-weight: 500;\r\n$body-2-weight-bold: 700;\r\n$body-2-size: 14px;\r\n$body-2-line-height: 20px;\r\n\r\n$body-3-weight: 400;\r\n$body-3-weight-bold: 700;\r\n$body-3-size: 12px;\r\n$body-3-line-height: 18px;\r\n\r\n/* --------- Pontuais\r\nPequenos textos para compor \r\nlegendas, botões e afins.*/\r\n$botao-1-font-weight: 700;\r\n$botao-1-font-size: 14px;\r\n$botao-1-line-height: 16px;\r\n$botao-1-letter-spacing: 1.5px;\r\n\r\n$botao-2-font-weight: 700;\r\n$botao-2-font-size: 12px;\r\n$botao-2-line-height: 16px;\r\n$botao-2-letter-spacing: 1px;\r\n\r\n$label-1-font-weight: 700;\r\n$label-1-font-size: 14px;\r\n$label-1-line-height: 16px;\r\n$label-1-letter-spacing: 1px;\r\n\r\n$label-2-font-weight: 700;\r\n$label-2-font-size: 12px;\r\n$label-2-line-height: 16px;\r\n$label-2-letter-spacing: 1px;\r\n\r\n$label-3-font-weight: 700;\r\n$label-3-font-size: 10px;\r\n$label-3-line-height: 14px;\r\n$label-3-letter-spacing: 0.25px;\r\n\r\n$caption-font-weight: 400;\r\n$caption-font-weight-bold: 700;\r\n$caption-font-size: 12px;\r\n$caption-line-height: 20px;\r\n$caption-letter-spacing: 0.25px;\r\n\r\n$breadcrumb-font-style: italic;\r\n$breadcrumb-font-decoration: underline;\r\n$breadcrumb-font-weight: 400;\r\n$breadcrumb-font-size: 10px;\r\n$breadcrumb-line-height: 14px;\r\n$breadcrumb-letter-spacing: 0.25px;\r\n\r\n$overline-font-weight: 400;\r\n$overline-font-size: 10px;\r\n$overline-line-height: 14px;\r\n$overline-letter-spacing: 1.5px;"],"sourceRoot":""}]);
// Exports
export var gridMU = `_epZ3RG1FSPn5DnVWO5W`;
export var formularioGridContainer = `kUxquKcUYmk_VSBjR8QP`;
export var formularioGridRow = `bFNcd0uVtFrn157nZjni`;
export var formularioGridColumn = `TZN7m1SN7PorIbTcNcPT`;
export var width1 = `bNDxUbnuWNcG6eYFachg`;
export var width2 = `UNKCZ_N4yuz4h4e_gqqy`;
export var width3 = `RrIQipTKVa3S6C0NVkLM`;
export var width4 = `MCpdoGwmvO3vC2gSgDzv`;
export var width5 = `W1DAIF93jdjNSXqaY0Zv`;
export var width6 = `ZM9mB3DeNIpbOMY9icVJ`;
export var width7 = `pjz5i_9IygDdzufC079G`;
export var width8 = `gpB23IM29qOTpNYdGuvu`;
export var width9 = `R1cGA3uaA5fgNgAuOrqb`;
export var width10 = `cw8U3xb5s8yzHbICng8M`;
export var width11 = `IQNlUi1KJEq1yld4sOwP`;
export var width12 = `AOkcS2PKxX3_TNHyQIIc`;
export var width13 = `vDVojwCXkLbXQg4_5Ej1`;
export var width14 = `CkIZUgAMUXE37SIjuWD0`;
export var width15 = `iKc5Hx7O1UlF2lHOplCg`;
export var width16 = `mBj_Diir4CHCQrYmc80l`;
export var width17 = `XUI5HyNNTFF7XEc78y70`;
export var width18 = `IwJRqDpyY1MNdzAjbTTL`;
export var width19 = `EMUeB2STJ6eKl_43tG8n`;
export var width20 = `xty4FA1WB2IqFzR3MyAK`;
export var width21 = `j9KKAG8LFvDyf8E1pZ3e`;
export var width22 = `X1qCdBTn28rZUJS7my8S`;
export var width23 = `y8dJZZRdEqHy3rOxugAS`;
export var width24 = `U8kBOdzFJmsRrOGQ0J1K`;
export var width25 = `cCztUuGrHZfWnozziw8Q`;
export var width26 = `yo_hwWeyxIWNOXhcMtQ0`;
export var width27 = `tMet84U4cGsXnTaFpdzk`;
export var width28 = `NnuPIu4SAAOZWSYA8Kes`;
export var width29 = `XXW6sa_xZuJcNqBIQ4Kn`;
export var width30 = `m5gbr_GTD96ZmyW3dKls`;
export var width31 = `K395eJqAvbee9s2o8v8i`;
export var width32 = `PL0_XiSDl0K3kTPnE2qH`;
export var width33 = `nWKPd86JC4VtBHnapKn9`;
export var width34 = `blDEVLZQcQCue0C4wSSz`;
export var width35 = `f9O1qCzJoTUJzduenpz7`;
export var width36 = `xsCRxcAyUvoVIuCSklTo`;
export var width37 = `j4BCIr4_DP6LocuzaYb0`;
export var width38 = `PT6b1V9TVqFEhM5e9DAt`;
export var width39 = `ievs36EKaiRLjZSsIAki`;
export var width40 = `tNlNVg9AgjhBNxiERyr5`;
export var width41 = `_WufVRiHWn6m29oRHuo1`;
export var width42 = `Tnz_QCcY2zBgMOUAchwY`;
export var width43 = `rak68GwPgOMAj_dV2yoh`;
export var width44 = `J8r0EEq2xOJF4jyCrmTU`;
export var width45 = `rlJSUROOHmbbS_X1K3up`;
export var width46 = `SS790qqWXBk3nt4xWWe9`;
export var width47 = `edJ7lbMTUp5D78_KMMhC`;
export var width48 = `Bj8j3X3Vs4oAgAuoMVA0`;
export var width49 = `Qx8R_miy7INlEDiWEEJ7`;
export var width50 = `T4igr1FJ7FfrTvHx5iZ5`;
export var width51 = `XNPpWkvakNLvr5VgrPWH`;
export var width52 = `R79GBNHS6AWWD0zfpB22`;
export var width53 = `QSh0z9gvCh_dadxdY2ps`;
export var width54 = `GpSL_oHeXSTLyu7gLrBC`;
export var width55 = `IWmSY5x_eAEKADThL8cB`;
export var width56 = `SUKIWBxCahSaMfrcSUAs`;
export var width57 = `ZjEDESEabC8BNwMD3N9p`;
export var width58 = `AQQwMvQvfQw3_RyZc6hX`;
export var width59 = `GrGr0EtW5Y3iQsv3sDKQ`;
export var width60 = `PXfrfsCyRynMncMAfOUM`;
export var width61 = `NT3wjCCmOP9v7Wok4U2E`;
export var width62 = `MJe4MEWTYUsZTbiZtZyw`;
export var width63 = `OZ57Ubst2KZeF8VYPYU7`;
export var width64 = `oU1ufbOjpt_c5TDzMo6M`;
export var width65 = `N6wWaABe83q6eODhUtin`;
export var width66 = `uky25hgfQgvAE_IqUtZG`;
export var width67 = `gOHCPPBnrvlwuhWPThTG`;
export var width68 = `gPhSCZECOQ6w3zzUDrMi`;
export var width69 = `EXekBJoYvs__WZw45zfC`;
export var width70 = `AjEdArAPKa_KuN7qrhz5`;
export var width71 = `c6BFUuGHPcMIhVyBb6Ak`;
export var width72 = `rf4QEZfDz1kJROMZKmag`;
export var width73 = `Lx2xv1Kc0Oz9Pl5W3KU3`;
export var width74 = `lWni0JUdFULGTPXb_3_h`;
export var width75 = `_vGcw2zUN26bXXIZUql4`;
export var width76 = `dw521P6JB7O5IQy4IRRe`;
export var width77 = `m2e3k3YjOiM1FFwqoGpY`;
export var width78 = `BFeI68xGpqCLLZjQBVRH`;
export var width79 = `uuHyNMt9EZ7rnDSiNqb7`;
export var width80 = `QDHZ50DsR7Upz0h7s1J2`;
export var width81 = `XXaN9acyogm10ugCayER`;
export var width82 = `kO0AwDouife8aDy3egoi`;
export var width83 = `oZ9zoSS4vs2wYJa1yI6n`;
export var width84 = `lCI7ojj0fX7rUxSjjfx_`;
export var width85 = `vA7VshOsoffGlz58VDg4`;
export var width86 = `qS6adJQ7xFBtjsSJImNJ`;
export var width87 = `y3qK9WvMzxs4rSY2ZPy1`;
export var width88 = `CY7t4PwaPk2prJ692fiE`;
export var width89 = `dUyVjyheHKD1f8Hj_q8h`;
export var width90 = `vr4UG7H_e_bBW2WYs0dX`;
export var width91 = `uJJt4QuWm93bRkCitckh`;
export var width92 = `fsk2IxzFvYEYo5a5MOwb`;
export var width93 = `ItL3ATxM1vUUj1UHq2cY`;
export var width94 = `rQFmbYUWlYMI579KnWFS`;
export var width95 = `ytSxsqv0jqaWvn0LUgIZ`;
export var width96 = `WWvKLJWXJ28LoA7tyIHF`;
export var width97 = `CIovhKAVecZyydqFlpZx`;
export var width98 = `UvNX5NNQS93wOaR9GubH`;
export var width99 = `d48vK0ww2sLt1xriuA7v`;
export var width100 = `G7Jv8619lieRUHk2Bpzy`;
export default ___CSS_LOADER_EXPORT___;
